import { t } from "i18next";
import React from "react";
import { RiderModel, RiderProductModel } from "../../Api/Models/rider.model";
import { ReturnStatus } from "../../Api/Models/return.model";
//import { useUser } from "../../Context/UserProvider";
import { CalendarIcon } from "../Icons/CalendarIcon";
import { ChangeIcon } from "../Icons/ChangeIcon";
import Popover from "../Popover";

interface GearsProps {
  gears: RiderProductModel[];
  setAssignNewGearItem: CallableFunction;
  rider: RiderModel;
}

const Gears: React.FunctionComponent<GearsProps> = ({
  gears,
  setAssignNewGearItem,
  rider,
}) => {
  //const { user } = useUser();

  const getGearColor = (gear: RiderProductModel) => {
    if (gear.reported) {
        return "yellow";
    }

    if (gear.discontinued) {
      return "black";
    }

    if (gear.returnDate && gear.returnStatus !== ReturnStatus.MISSING) {
      return "grey";
    }

    if (!gear.exchangeDays || gear.returnStatus === ReturnStatus.MISSING) {
      return "red";
    }

    if (gear.exchangeDays <= 7) {
      return "orange";
    }

    return "green";
  };

  console.log(gears);

  

  return (
    <>
      <div className="">
        {gears.length > 0 && (
          <div className="">
            {gears.map((gear, index) => (
              <React.Fragment key={index}>
                <div className="product-list-card mb-4">
                  <div className="flex gap-2">
                    <div className="relative">
                      <div className="product-list-card__image">
                        <img src={gear.productImage} alt="package name" />
                      </div>

                      {gear.variationName && (
                        <div className="product-list-card__variation-name">
                          {gear.variationName}
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col justify-between w-full">
                      <div className="flex justify-between gap-2">
                        <div className="product-list-card__title">
                            {gear.productName}
                        </div>
                        <div>

                          <Popover defaultPosition={"left"} text={t("Reported by T-patroller")}>
                            <div className={"status-bubble " + getGearColor(gear)}></div>
                          </Popover>
                          

                        </div>
                      </div>

                      <div className="flex justify-between gap-2">
                        <div>
                            {gear.returnDate ? (
                              <div className="flex gap-1 items-center color-secondary">
                                {/*{t("Return Date")}:*/}
                                <CalendarIcon />
                                {gear.returnDate}
                              </div>
                            ) : (
                              <div className="flex gap-1 items-center color-secondary">
                                {/*{t("Assign Date")}:&nbsp;*/}
                                <CalendarIcon />
                                {gear.assignedAt}
                              </div>
                            )}
                          </div>
                          <div>
                            {gear.discontinued ? (
                              <span className="font-8">{t("Discountinued")}</span>
                            ) : (gear?.exchangeDays ?? 0) > 0 ? (
                              <div className="product-list-card__status product-list-card__status--blue">
                                {/*{t("Days until")}*/}
                                <ChangeIcon />
                                {gear.exchangeDays} {t('day')}
                              </div>
                            ) : <div className="product-list-card__status product-list-card__status--red">
                                <ChangeIcon />
                                0 {t('day')}
                              </div>}
                          </div>
                        </div>
                    </div>
                  
                </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Gears;
